// removed by extract-text-webpack-plugin
module.exports = {"LinkText":"_56lXK","LinkTextNormal":"_16HKr","LinkTextFill":"_3n6lC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TextLink/TextLink.scss
// module id = 456
// module chunks = 0